var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNgn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7704 2.58362H0.75293V11.2621H13.7704V2.58362Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09201 2.58362H0.75293V11.2621H5.09201V2.58362Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7707 2.58362H9.43164V11.2621H13.7707V2.58362Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0175,
    height: 13.0175,
    fill: "white",
    transform: "translate(0.75293 0.414062)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgn);
export default __webpack_public_path__ + "static/media/ngn.1d1372cbd2e7742f4a7c863dbfb50bdc.svg";
export { ForwardRef as ReactComponent };